module.exports = __webpack_public_path__ + "img/9.fe98da57.png";